import esContent from './home.es';

export default {
  ...esContent,
};
